const routes = [
  {
    path: '',
    name: '',
    component: () =>
      import('@/views/student/evaluation-discussion/Wrapper.vue'),
      children: [
      {
        path: '/student/evaluationdiscuss/history',
        name: 'MainEvaluationDiscussHistory',
        component: () =>
          import('@/views/student/evaluation-discussion/history/Main.vue'),
      },
      {
        path: '/student/evaluationdiscuss/addrprequest/:StudentSieId',
        name: 'MainCreateRpRequest',
        component: () =>
          import('@/views/student/evaluation-discussion/create-rp-request/Main.vue'),
      },
      {
        path: '/student/evaluationdiscuss/:studentSIE/:placementCommitteeId?',
        name: 'MainEvaluationDiscuss',
        component: () =>
          import('@/views/student/evaluation-discussion/Main.vue'),
      },
    ],
  },
];

export default routes;
